<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          icon
          :disabled="disabled" 
          color="red darken-4" 
          v-bind="attrs" 
          v-on="on" 
          title="Excluir"
          @click="dialog = !dialog"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>Excluir</span>
    </v-tooltip>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ctitulo}}</v-card-title>
        <v-card-text>{{ctexto}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="cancelar">Cancelar</v-btn>
          <v-btn color="red darken-1" text @click="confirmar">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    ctitulo: {
      type: String,
      default: "Atenção"
    },
    ctexto: {
      type: String,
      default: "Tem certeza que deseja excluir o item?"
    },
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    confirmar(e) {
      this.dialog = false;
      this.$emit("confirm", e);
    },
    cancelar(e) {
      this.dialog = false;
      this.$emit("cancel", e);
    }
  }
};
</script>

